import { interpolateTemplate } from 'lib/i18n/dictionary';

import type { StorageUsage } from './storage-usage.api';

const BYTES_PER_GB = 1024 * 1024 * 1024;

// "1.2" for 1.2 GB; whole numbers without a decimal ("3").
export function formatGigabytes(bytes: number) {
  const gigabytes = Math.round((bytes / BYTES_PER_GB) * 10) / 10;
  return Number.isInteger(gigabytes) ? String(gigabytes) : gigabytes.toFixed(1);
}

export function formatStorageUsage(
  usage: StorageUsage,
  template: string,
  unlimitedTemplate: string
) {
  return interpolateTemplate(usage.limitBytes === null ? unlimitedTemplate : template, {
    used: formatGigabytes(usage.usedBytes),
    limit: formatGigabytes(usage.limitBytes ?? 0),
  });
}
